import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Row, Col, Card, DatePicker, Typography, Divider } from "antd";
import moment from "moment";

import { GeneralStyledContent } from "../../../../styled/common-styled";
import EngineSummaryGraph from "./EngineSummaryGraph";
import SafetyGraph from "./SafetyGraph";
import ParkingGraph from "./ParkingGraph";
import PieChart from "./PieChart"
import LangContext from "modules/shared/context/langContext";

const { RangePicker } = DatePicker;
const { Title } = Typography;

const dateFormat = "YYYY/MM/DD";

const genHeader = (title, value) => {
  return (
    <Fragment>
      <Row>
        <Col>{title}</Col>
      </Row>
      <Row>
        <Col style={{ textAlign: "right" }}>{value}</Col>
      </Row>
    </Fragment>
  );
};

export class Layout extends Component {
  static contextType = LangContext

  render() {
    const ds = this.context.dashboard_summary || {}
    return (
      <GeneralStyledContent>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Row gutter={[16, 8]}>
              <Col span={8}>
                <Title level={4}>{ds.title} 01/10/2020 {ds.to} 10/10/2020</Title>
              </Col>
              <Col span={12} offset={4}>
                <Row gutter={[16, 8]}>
                  <Col offset={6} span={6}>
                    <Title level={4}>{ds.pick_date}</Title>
                  </Col>
                  <Col span={12}>
                    <RangePicker
                      defaultValue={[
                        moment("2020/01/01", dateFormat),
                        moment("2020/01/01", dateFormat),
                      ]}
                      format={dateFormat}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>

        <Divider />

        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Card
              size="small"
              title={`${ds.enginePanel} (413 ${ds.unit})`}
              style={{ width: "100%" }}
            >
              <Row gutter={[8, 8]}>
                <Col span={24} style={{ height: "400px" }}>
                  <EngineSummaryGraph />
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>

        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Card
              size="small"
              title={ds.safetyPanel}
              style={{ width: "100%" }}
            >
              <Row gutter={[8, 8]}>
                <Col span={24} style={{ height: "400px" }}>
                  <SafetyGraph />
                </Col>
              </Row>
            </Card>
          </Col>
          <Col span={12}>
            <Card
              size="small"
              title={`${this.context.s.summary} ${ds.parking}`}
              style={{ width: "100%" }}
            >
              <Row gutter={[8, 8]}>
                <Col span={24} style={{ height: "400px" }}>
                  <ParkingGraph />
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>


        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Card
              size="small"
              title={this.context.d.deliveryOnTime || 'ส่งตรงเวลา'}
              style={{ width: "100%" }}
            >
              <Row gutter={[8, 8]}>
                <Col span={24} style={{ height: "400px" }}>
                  <PieChart value={1} />
                </Col>
              </Row>
            </Card>
          </Col>
          <Col span={12}>
            <Card
              size="small"
              title={this.context.u.unloadOutsideTheArea}
              style={{ width: "100%" }}
            >
              <Row gutter={[8, 8]}>
                <Col span={24} style={{ height: "400px" }}>
                  <PieChart value={2}/>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>

        <Row gutter={[16, 16]}>
          <Col span={8}>
            <Card
              size="small"
              title={genHeader(ds.fuelAvgPanel, `3.39 ${this.context.k.km}/${ds.lite}`)}
              style={{ width: "100%" }}
            >
              <Row gutter={[16, 8]}>
                <Col span={12}>{ds.distance}</Col>
                <Col span={12} style={{ textAlign: "right" }}>
                  140,984.4 {this.context.k.km}
                </Col>
              </Row>
              <Row gutter={[16, 8]}>
                <Col span={12}>{ds.fuelSummary}</Col>
                <Col span={12} style={{ textAlign: "right" }}>
                  41,575.1 {ds.lite}
                </Col>
              </Row>
            </Card>
          </Col>
          <Col span={8}>
            <Card
              size="small"
              title={genHeader(ds.parkingPanel, `14,523 ${ds.hours} 0 ${this.context.m.minute}`)}
              style={{ width: "100%" }}
            >
              <Row gutter={[16, 8]}>
                <Col span={12}>{ds.fuelUse}</Col>
                <Col span={12} style={{ textAlign: "right" }}>
                  11,492.3 {ds.lite}
                </Col>
              </Row>
              <Row gutter={[16, 8]}>
                <Col span={12}>{ds.fuelToBath}</Col>
                <Col span={12} style={{ textAlign: "right" }}>
                  213,642 {this.context.b.baht}
                </Col>
              </Row>
            </Card>
          </Col>
          <Col span={8}>
            <Card
              size="small"
              title={genHeader(ds.speedPanel, `25 ${ds.unit}`)}
              style={{ width: "100%" }}
            >
              <Row gutter={[16, 8]}>
                <Col span={12}>{ds.speedOver}</Col>
                <Col span={12} style={{ textAlign: "right" }}>
                  13 {ds.hours} 18 {this.context.m.minute}
                </Col>
              </Row>
              <Row gutter={[16, 8]}>
                <Col span={12}>{ds.maxSpeed}</Col>
                <Col span={12} style={{ textAlign: "right" }}>
                  254 {this.context.k.km}/{ds.hours}
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </GeneralStyledContent>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
